const updateStates = (states, newValues) => ({
  ...states,
  ...newValues,
});

export { updateStates };
